var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusiness = function SvgBusiness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.5 4H14a1.5 1.5 0 0 1 1.5 1.5V7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F4651",
    d: "m17.328 19.828-.53-.53zM16.5 1.75a.75.75 0 0 0 0-1.5zM17.75 9v4h1.5V9zM10.5 20.25h-1v1.5h1zM2.25 13V4H.75v9zm7.25 7.25c-1.907 0-3.261-.002-4.29-.14-1.005-.135-1.585-.389-2.008-.812l-1.06 1.06c.748.75 1.697 1.081 2.869 1.239 1.15.155 2.625.153 4.489.153zM.75 13c0 1.864-.002 3.338.153 4.489.158 1.172.49 2.121 1.238 2.87l1.06-1.06c-.422-.424-.676-1.004-.811-2.01-.138-1.027-.14-2.382-.14-4.289zm17 0c0 1.907-.002 3.262-.14 4.29-.135 1.005-.389 1.585-.812 2.008l1.06 1.06c.75-.748 1.081-1.697 1.239-2.869.155-1.15.153-2.625.153-4.489zm-7.25 8.75c1.864 0 3.338.002 4.489-.153 1.172-.158 2.121-.49 2.87-1.238l-1.06-1.06c-.424.422-1.004.676-2.01.811-1.027.138-2.382.14-4.289.14zm6-21.5h-12v1.5h12zm-12 7.5h12v-1.5h-12zM.75 4A3.75 3.75 0 0 0 4.5 7.75v-1.5A2.25 2.25 0 0 1 2.25 4zM4.5.25A3.75 3.75 0 0 0 .75 4h1.5A2.25 2.25 0 0 1 4.5 1.75zM19.25 9a2.75 2.75 0 0 0-2.75-2.75v1.5c.69 0 1.25.56 1.25 1.25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F4651",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13 12H7M10 16H7"
  })));
};
export default SvgBusiness;